
import * as React from 'react';

class Mission extends React.PureComponent {
  render(): JSX.Element {
    return (
      <div>
        <section id="feature-header" className="feature-header">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <h2 className="lg-title text-center">
                  <span>Mission and Vision</span>
                </h2>
              </div>
              {/*/.col*/}
              {/* <div className="col-md-8 col-sm-12 col-xs-12 col-md-offset-2">
                <p className="lg-text text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco</p>
              </div> */}
              {/*/.col*/}
            </div>
            {/*/.row*/}
          </div>
          {/*/.container*/}
        </section>
        <section id="feature" className="feature pad-80">
          <div className="container">
            <div className="row">
              <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="feature-wrap">
                  <div className="icon-wrap">
                    <i className="fa fa-child" />
                  </div>
                  <h3>Our Vision</h3>
                  <p>Our vision is to be an institution that effectively contributes to the integral development of girls and young women in Timor-Leste.</p>
                </div>
              </div>
              {/*/.col*/}
              <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="feature-wrap">
                  <div className="icon-wrap">
                    <i className="fa fa-globe" />
                  </div>
                  <h3>Our Mission</h3>
                  <p>To promote capacity-building and personal, educational, social and economic development for vulnerable girls and young women living in underdeveloped communities in Timor-Leste, in order to strengthen their autonomy, raise their leadership and increase their employability.
</p>
                </div>
              </div>
              {/*/.col*/}
              <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="feature-wrap">
                  <div className="icon-wrap">
                    <i className="fa fa-user" />
                  </div>
                  <h3>Our Value</h3>
                  <p>Accountability, child protection, compassion, excellence, integrity, partnerships.</p>
                </div>
              </div>
              {/*/.col*/}
            </div>
            {/*/.row*/}
          </div>
          {/*/.container*/}
        </section>
      </div>
    );
  }
}

export default Mission;



// WEBPACK FOOTER //
// ./src/components/Mission.tsx